import React, { useCallback, useRef } from "react";
import Highcharts from "highcharts";
import HighchartsReact from "highcharts-react-official";
import useReport from "../../Hooks/report";
import { Stack } from "@mui/material";
import { getColor } from "../../Utils/getIcons";
import Loader from "../../common/Loader";

const ReportChartComponent = () => {
  const { reportChartPercentageData,loading } = useReport();
  var options = {
    chart: {
      type: "column",
    },
    // tooltip: {
    //   outside: true,
    //   useHTML: true,
    //   formatter: function () {
    //     return `<div class="tooltip">The value for <b>${this.x}</b> is <b>${this.y}</b></div>`;
    //   },
    // },
    credits: {
      enabled: false,
      formatter: function () {
        return <span>{this.point.name}</span>;
      },
    },
    title: {
      text: "",
    },
    xAxis: {
      categories: ["data"],
      labels: {
        enabled: true,
      },
      tickLength: 1,
      min: 0,
    },
    yAxis: [
      {
        max: 100,
      },
    ],

    plotOptions: {
      series: {
        borderRadius: 3,
        pointPadding: 0,
        groupPadding: 0.05,
      },
    },
    series:
    reportChartPercentageData &&
    reportChartPercentageData.map((_el) => ({
        name: _el.departmentName,
        data: [_el.strength],
        color: getColor(_el.departmentName).linerColor,
      })),
  };

  return (
    <>    
      <Stack sx={{ my: 4 }}>
      <HighchartsReact
        constructorType={"chart"}
        highcharts={Highcharts}
        options={options}
      />
    </Stack>
    </>

  );
};

export default ReportChartComponent;
